<template>
	<div class="paypal-buttons">
		<div
			v-show="initializingPaypal"
			class="paypal-buttons__button --empty --full-width"
			aria-label="Loading paypal express"
			aria-busy="true"
			aria-live="polite"
		/>

		<div
			v-show="!initializingPaypal"
			id="paypal-button"
			class="paypal-buttons__button --full-width"
			:class="{
				'--disabled': disable,
			}"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapState('checkout', ['initializingPaypal', 'modifyingCart']),
		...mapGetters('checkout', ['formHasErrors']),
		disable() {
			return this.modifyingCart || this.formHasErrors;
		},
	},
};
</script>

<style lang="scss" scoped>
.paypal-buttons {
	--paypal-gold: #ffc439;
	--button-height: 45px;

	display: grid;
	grid-template-columns: 1fr;
	gap: var(--size-sm);

	@media screen and (min-width: 992px) {
		grid-template-columns: 1fr 1fr;
	}

	&__button {
		height: var(--button-height);
		width: 100%;
		border-radius: 4px;

		&.--full-width {
			grid-column: span 2;
		}

		&.--empty {
			background: var(--gray-200);
			position: relative;
			overflow: hidden;

			&::after {
				will-change: transform;
				position: absolute;
				content: '';
				animation: shimmer 2s infinite;
				inset: 0;
				width: 100%;
				background: linear-gradient(
					to right,
					var(--gray-200) 4%,
					var(--gray-300) 25%,
					var(--gray-200) 36%
				);
			}
		}

		&.--paypal-placeholder {
			border: none;
			background: var(--paypal-gold);
			transition: all 300ms ease;

			&:hover {
				box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);
			}
		}

		&.--disabled {
			opacity: 0.65;
			pointer-events: none;
		}

		&.--no-pointer {
			pointer-events: none;
		}
	}
}
</style>
